module.exports = __webpack_public_path__ + "img/tiandong.ea1912f0.png";